import { api } from "../utils/AuthManager";
const GetSummary = async () => {
  return api
    .get(`/api/summary/`)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetSummary;
